export default __webpack_public_path__ + "static/media/28.12bdb28a.wav";